// client/src/hooks/useHorariosTrabalho.js - VERSÃO CORRIGIDA E VALIDADA
import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';
import { useMemo } from 'react';
import { parseISO, isSameDay } from 'date-fns';

const HORARIOS_TRABALHO_KEY = 'horariosTrabalho';

/**
 * Hook para buscar todas as regras de horário de trabalho que se aplicam a um conjunto de entidades
 * em um determinado dia da semana e unidade.
 * 
 * ✅ CORREÇÃO: Adicionado tratamento para erro 500 (retorna array vazio em vez de lançar exceção)
 * ✅ CORREÇÃO: Retorna tanto horários semanais quanto datas únicas
 */
export const useHorariosTrabalho = (params, options = {}) => {
    // Estabiliza os parâmetros para evitar re-fetches desnecessários
    const stableParams = useMemo(() => params, [JSON.stringify(params)]);
    
    // Constrói a query key dinâmica
    const queryKey = [HORARIOS_TRABALHO_KEY, stableParams];

    // Verifica se a query deve ser ativada
    const enabled = (
        (stableParams.diaDaSemana !== null && stableParams.diaDaSemana !== undefined) && 
        !!stableParams.unidade && 
        !!stableParams['entidadeAgendavel[in]'] && 
        stableParams['entidadeAgendavel[in]'] !== 'none'
    ) && options.enabled !== false;

    return useQuery({
        queryKey: queryKey,
        queryFn: async () => {
            try {
                const { data } = await apiClient.get('/horarios/dias-de-trabalho', { params: stableParams });
                return data.data || [];
            } catch (error) {
                // ✅ CORREÇÃO: Tratamento específico para erro 500
                if (error.response?.status === 500) {
                    console.warn('⚠️ [useHorariosTrabalho] Erro 500 ao buscar horários, retornando array vazio.');
                    return [];
                }
                console.error('❌ [useHorariosTrabalho] Erro ao buscar dias de trabalho:', error);
                throw error;
            }
        },
        enabled: enabled,
        staleTime: 5 * 60 * 1000, // 5 minutos de cache
        retry: (failureCount, error) => {
            // ✅ CORREÇÃO: Não tentar novamente para erros 500
            if (error.response?.status === 500) {
                return false;
            }
            return failureCount < 2;
        }
    });
};

export default useHorariosTrabalho;